// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 20px;
  /* background-color: white; */
  color: #333;
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}
.leftWrapper {
  display: flex;
  align-items: center;
}
.logos {
  font-size: 24px;
  /* font-weight: bold; */
  margin-right: 100px;
  display: flex;
  gap: 10px;
}
.dummyList {
  display: flex;
  align-items: center;
  gap: 50px;
}
.dummyList p {
  padding: 10px 50px;
  background-color: #EEEBFF;
  color: #333;

}
.menu-icon {
  font-size: 28px;
  cursor: pointer;
  background-color: var(--icon2-bg-color);
  color: var(--primary-color);
  padding: 5px 10px;
  border-radius: 5px;
}
.sidebars {
  position: fixed;
  top: 0;
  right: -250px;
  width: 250px;
  height: 100%;
 /* : #B17CDD; */
  background-color: var(--secondary-dark-bg);
  color: white;
  padding: 20px;
  box-shadow: -3px 0 5px rgba(0, 0, 0, 0.5);
  transition: transform 0.3s ease-in-out; 
}

.sidebars.open {
  transform: translateX(-250px); 
}

.sidebars.closed {
  transform: translateX(0); 
}



@media (max-width: 768px) {
  .dummyList {
    display: none;
  }

  .logos {
    font-size: 20px;
    font-weight: bold;
  }

  /* Change the logo name */
  /* .logo::after {
      content: ' NewLogo';
    } */

  /* .logo::before {
        content: 'NewLogo'; 
      } */

  .logos {
    font-size: 20px;
    gap: 10px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/Component/Header/MobileHeaderStyle.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,6BAA6B;EAC7B,WAAW;EACX,iDAAiD;AACnD;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;;AAEb;AACA;EACE,eAAe;EACf,eAAe;EACf,uCAAuC;EACvC,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,MAAM;EACN,aAAa;EACb,YAAY;EACZ,YAAY;CACb,eAAe;EACd,0CAA0C;EAC1C,YAAY;EACZ,aAAa;EACb,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;;;AAIA;EACE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA,yBAAyB;EACzB;;OAEK;;EAEL;;SAEO;;EAEP;IACE,eAAe;IACf,SAAS;EACX;AACF","sourcesContent":[".header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 20px;\n  /* background-color: white; */\n  color: #333;\n  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;\n}\n.leftWrapper {\n  display: flex;\n  align-items: center;\n}\n.logos {\n  font-size: 24px;\n  /* font-weight: bold; */\n  margin-right: 100px;\n  display: flex;\n  gap: 10px;\n}\n.dummyList {\n  display: flex;\n  align-items: center;\n  gap: 50px;\n}\n.dummyList p {\n  padding: 10px 50px;\n  background-color: #EEEBFF;\n  color: #333;\n\n}\n.menu-icon {\n  font-size: 28px;\n  cursor: pointer;\n  background-color: var(--icon2-bg-color);\n  color: var(--primary-color);\n  padding: 5px 10px;\n  border-radius: 5px;\n}\n.sidebars {\n  position: fixed;\n  top: 0;\n  right: -250px;\n  width: 250px;\n  height: 100%;\n /* : #B17CDD; */\n  background-color: var(--secondary-dark-bg);\n  color: white;\n  padding: 20px;\n  box-shadow: -3px 0 5px rgba(0, 0, 0, 0.5);\n  transition: transform 0.3s ease-in-out; \n}\n\n.sidebars.open {\n  transform: translateX(-250px); \n}\n\n.sidebars.closed {\n  transform: translateX(0); \n}\n\n\n\n@media (max-width: 768px) {\n  .dummyList {\n    display: none;\n  }\n\n  .logos {\n    font-size: 20px;\n    font-weight: bold;\n  }\n\n  /* Change the logo name */\n  /* .logo::after {\n      content: ' NewLogo';\n    } */\n\n  /* .logo::before {\n        content: 'NewLogo'; \n      } */\n\n  .logos {\n    font-size: 20px;\n    gap: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
